// Import the shiny new tools we just built
import { apiFetch } from "../services/apiService";

export interface TranscriptSegment {
  start: number;
  end: number;
  text: string;
  speaker?: string;
}

export interface JobItem {
  job_id: string;
  status: "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED"; // NOTE: Processing is never used, but defensive
  created_at: string;
  s3_key: string;
  audio_duration?: number | null;
  processing_rate?: number;
  processing_time?: number;
  filename?: string;
}

export interface TranscriptionResponse {
  job_id: string;
  s3_key: string;
  segments: TranscriptSegment[];
}

export interface ListJobsResponse {
  items: JobItem[];
  next_token: string | null;
}

export const TranscriptionService = {
  getUploadUrl: async (): Promise<{ job_id: string; upload_url: string }> => {
    const res = await apiFetch("transcription/upload-url", {
      method: "POST",
    });
    return (await res.json()) as { job_id: string; upload_url: string };
  },

  submitJob: async (
    jobId: string,
    filename: string,
  ): Promise<{ job_id: string; status: string }> => {
    const res = await apiFetch("transcription/jobs", {
      method: "POST",
      body: JSON.stringify({
        job_id: jobId,
        filename: filename,
      }),
    });
    return (await res.json()) as { job_id: string; status: string };
  },

  listJobs: async (limit = 10, lastKey?: string): Promise<ListJobsResponse> => {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (lastKey) params.append("last_key", lastKey);

    const res = await apiFetch(`transcription/jobs?${params}`, {
      method: "GET",
    });
    return (await res.json()) as ListJobsResponse;
  },

  getJobStatus: async (jobId: string): Promise<JobItem> => {
    const res = await apiFetch(`transcription/jobs/${jobId}`, {
      method: "GET",
    });
    return (await res.json()) as JobItem;
  },

  getTranscription: async (jobId: string): Promise<TranscriptionResponse> => {
    const res = await apiFetch(`transcription/jobs/${jobId}/transcription`, {
      method: "GET",
    });
    return (await res.json()) as TranscriptionResponse;
  },

  getAudioUrl: async (jobId: string): Promise<{ audio_url: string }> => {
    const res = await apiFetch(`transcription/jobs/${jobId}/audio`, {
      method: "GET",
    });
    return (await res.json()) as { audio_url: string };
  },
};
